'use client';

import { normalizeErrorForLogging } from '@/utils/error-normalizer';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

class ClientErrorLoggerApiService {
  private appInsights: ApplicationInsights | null = null;

  initialize(connectionString: string): void {
    if (this.appInsights || !connectionString) {
      return;
    }

    try {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString,
          enableAutoRouteTracking: true,
        },
      });

      this.appInsights.loadAppInsights();
    } catch {
      console.error('Failed to initialize Application Insights');
    }
  }

  logError(
    error: Error | unknown
  ): void {
    if (!this.appInsights) {
      return;
    }

    try {
      const prefixedError = normalizeErrorForLogging(error);

      this.appInsights.trackException({
        exception: prefixedError,
        properties: {
          boundary: 'error-boundary',
          clientSide: true,
          location: window.location.href,
          stack: prefixedError.stack,
          timestamp: new Date().toISOString(),
        },
      });
    } catch {
      console.error('Failed to log error to Application Insights');
    }
  }
}

export const clientErrorLoggerApiService = new ClientErrorLoggerApiService();
